import { Button, Stack, styled } from "@mui/material";
import { COLORS } from "constants/layout";

export const StyledBox = styled(Stack)(({ theme }) => ({
  padding: 16,
  backgroundColor: "#fff",
  borderRadius: 8,
  ".tmp-box": {
    button: {
      height: 32,
      fontSize: 12,
      width: "50%",
    },
    ".clear-btn": {
      color: COLORS.gray[500],
      backgroundColor: COLORS.gray[100],
      border: "none",
    },
  },
  ".flag-img": {
    width: 16,
    height: 12,
  },
  ".filter-box": {
    maxHeight: 164,
    overflow: "hidden",
    overflowY: "scroll",
  },
  ".search-input .MuiInputBase-root": {
    height: 30,
  },
  [theme.breakpoints.down("md")]: {
    position: "initial",
  },
}));

export const StyledShortFilter = styled(Button)({
  justifyContent: "flex-start",
  textTransform: "initial",
  border: "0.5px solid #979797",
  padding: "8px 12px",
});
